import {
  Box,
  Flex,
  Image as ChakraImage,
  Text,
  VStack,
  Icon,
  Image,
  Show,
  Link,
} from "@chakra-ui/react";
import { formatMoney } from "../../utils";
import { useRouter } from "next/router";
import React from "react";
import { FaShoppingCart } from "react-icons/fa";
import { BsChevronRight } from "react-icons/bs";
import trophy from "../../../public/trophy.png";

export default function WishlistCardHorizontalPublic({
  currency,
  wishlist,
  donators,
  onClick,
  ...props
}) {
  const router = useRouter();

  const onClickDetail = () => {
    // router.push(`/overlays/wishlist/${wishlist.id}`);
    router.push(`/wishlist/${wishlist.id}`);
  };

  return (
    <>
      <Box
        w="100%"
        borderRadius="6px"
        bg="#f2f7f5"
        border="0.7px solid #000"
        p={{ base: "16px", md: "20px" }}
        display="flex"
        flexDirection="column"
        gap="16px"
        fontSize="18px"
        fontFamily="'IBM Plex Mono'"
        color="#000"
        textAlign="left"
        borderLeft={wishlist.type === "CROWDFUND" ? "1px" : "4px solid #D88B0F"}
        onClick={onClick}
        cursor="pointer"
      >
        {/* Top Section */}
        <Flex w="100%" gap="24px" align="flex-start">
          <Box
            flexShrink={0}
            mr="14px"
            borderRadius="6px"
            overflow="hidden"
            w={{ base: "60px", md: "120px" }}
            h={{ base: "60px", md: "120px" }}
            position="relative"
          >
            <Image
              src={wishlist.image_url}
              alt=""
              width={{ base: "60px", md: "120px" }}
              height={{ base: "60px", md: "120px" }}
              fill
              style={{ objectFit: "cover", borderRadius: "6px" }}
            />
          </Box>

          {/* Product Info */}
          <VStack
            align="flex-start"
            justify="center"
            gap="12px"
            flex="1"
            minW={0}
          >
            {/* Header */}
            <Box
              display={{ base: "flex", md: "flex" }}
              justifyContent="space-between"
              alignItems="start"
              gap="6.8px"
              w="100%"
              minW={0}
            >
              <Text
                textAlign="left"
                fontWeight="bold"
                lineHeight="28px"
                fontSize={{ base: "md", md: "lg" }}
                minW={0}
                mb={{ base: 1, md: 0 }}
                noOfLines={{ base: 2, md: 1 }}
                overflow="hidden"
                textOverflow="ellipsis"
                mt="-2px"
              >
                {wishlist.product_name}
              </Text>

              <Link href={wishlist.link} textDecoration="none" flexShrink={0}>
                <Flex
                  display="inline-flex"
                  align="center"
                  gap="8px"
                  fontSize="18px"
                  color="#2D3748"
                  minW={0}
                >
                  <Icon
                    as={BsChevronRight}
                    boxSize="16px"
                    ml="8px"
                    strokeWidth="1.5"
                  />
                </Flex>
              </Link>
            </Box>

            {/* Progress */}
            <Show above="md">
              <VStack
                align="flex-start"
                gap="8px"
                fontSize="14px"
                color="#dd6b20"
                w="100%"
                minW={0}
              >
                <Flex align="center" gap="4px" color="#000" minW={0}>
                  <Icon
                    as={FaShoppingCart}
                    boxSize="14px"
                    color="#3182CE"
                    marginRight="4px"
                  />
                  <Text fontSize="14px" isTruncated minW={0}>
                    {wishlist.ecommerce_name}
                  </Text>
                </Flex>
              </VStack>

              {/* Price */}
              <Text fontSize="16px" lineHeight="24px" isTruncated minW={0}>
                {wishlist.type === "FULLY_FUNDED" ? (
                  <b>
                    {formatMoney(wishlist.total_price, {
                      formatWithSymbol: true,
                      currency: currency ?? "IDR",
                    })}{" "}
                  </b>
                ) : (
                  <>
                    <b>
                      {formatMoney(wishlist.total_donation, {
                        formatWithSymbol: true,
                        currency: currency ?? "IDR",
                      })}{" "}
                    </b>
                    /{" "}
                    {formatMoney(wishlist.total_price, {
                      formatWithSymbol: true,
                      currency: currency ?? "IDR",
                    })}
                  </>
                )}
              </Text>
            </Show>
          </VStack>
        </Flex>

        <Show below="md">
          <Text
            fontSize={{ base: "14px", md: "16px" }}
            whiteSpace="pre-line"
            lineHeight="24px"
            isTruncated
            minW={0}
            mt={2}
          >
            {wishlist.type === "FULLY_FUNDED" ? (
              <b>
                {formatMoney(wishlist.total_price, {
                  formatWithSymbol: true,
                  currency: currency ?? "IDR",
                })}{" "}
              </b>
            ) : (
              <>
                <b>
                  {formatMoney(wishlist.total_donation, {
                    formatWithSymbol: true,
                    currency: currency ?? "IDR",
                  })}{" "}
                </b>
                /{" "}
                {formatMoney(wishlist.total_price, {
                  formatWithSymbol: true,
                  currency: currency ?? "IDR",
                })}
              </>
            )}
          </Text>
        </Show>

        {/* Donator Section */}
        {wishlist.top_donator && wishlist.top_donator.length > 0 && (
          <Flex gap="8px" mt="4px" flexWrap="wrap">
            {wishlist.top_donator.slice(0, 3).map((donator, idx) => {
              const medals = [
                "/gold-medal.png",
                "/silver-medal.png",
                "/bronze-medal.png",
              ];

              const isCrowdfund = wishlist.type === "CROWDFUND";
              const bgStyle = isCrowdfund
                ? "#DDDEDE"
                : "linear-gradient(89.94deg, #FAAE2C -315.72%, #F2F7F5 99.96%)";
              const borderStyle = isCrowdfund
                ? "1px solid #E2E8F0"
                : "1px solid #DD6B20";

              // ⬇️ logika pemilihan ikon
              const iconSrc = !isCrowdfund
                ? "/trophy.png"
                : medals[idx] || "/blue-medal.png";

              return (
                <Flex
                  key={donator.donator_name}
                  align="center"
                  gap="6px"
                  px="10px"
                  py="4px"
                  mt="10px"
                  mr="10px"
                  borderRadius="6px"
                  bg={bgStyle}
                  border={borderStyle}
                >
                  <Image
                    src={iconSrc}
                    alt={`Rank ${idx + 1}`}
                    width={4}
                    height={4}
                    mr={2}
                    style={{ objectFit: "contain" }}
                  />
                  <Text fontSize="14px" isTruncated maxW="120px" color="#000">
                    {donator.donator_name}
                  </Text>
                </Flex>
              );
            })}

            {/* Badge "+X Lainnya" */}
            {wishlist.total_donator > 3 && (
              <Flex
                align="center"
                gap="6px"
                px="10px"
                py="4px"
                mt="10px"
                borderRadius="6px"
                bg={wishlist.type === "CROWDFUND" ? "#DDDEDE" : "#FFF8F0"}
                border={
                  wishlist.type === "CROWDFUND"
                    ? "1px solid #E2E8F0"
                    : "1px solid #DD6B20"
                }
              >
                {/* ⬇️ kalau CROWDFUND tetap trophy, kalau bukan pakai blue-medal */}
                <Image
                  src={
                    wishlist.type === "FULLY_FUNDED"
                      ? "/trophy.png"
                      : "/blue-medal.png"
                  }
                  alt="Others"
                  width={4}
                  height={4}
                  mr={2}
                  style={{ objectFit: "contain" }}
                />
                <Text fontSize="14px" color="#000">
                  +{(wishlist.total_donator - 3).toLocaleString()} Lainnya
                </Text>
              </Flex>
            )}
          </Flex>
        )}
      </Box>
    </>
  );
}
